import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation/';
import Island from '../../components/Island/';
import Instagram from '../../components/Cards/instagram';
import Beach from '../../components/Cards/beach';
import PageHeader from '../../components/PageHeader';
import Amenities from '../../utils/amenities';
import Tip from '../../components/Tips';

import fiferries from '../../assets/img/instagram/profiles/fiferries.jpg';
import sunsetLighthouse from '../../assets/img/instagram/lighthousesunset@fiferries.jpg';
// import BeachCard from '../../components/Cards/beach';

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Fire Island Lighthouse"
      meta={[
        { name: 'description', content: 'An iconic landmark of Fire Island. Climb to the top for a breathtaking panoramic view.' },
        { name: 'keywords', content: 'Fire Island Lighthouse, Lighthouse, Fire Island, New York, Long Island, Ferries, Water Taxi' },
      ]}
    />
    <Navigation />
    <div className="container p-0">
      <PageHeader beach="F.I. Lighthouse">
        <h2>Communities</h2>
        <h1>F.I. Lighthouse</h1>
        <div>
          <Link className="btn btn-outline-light" to="/directory">Directory</Link>
        </div>
      </PageHeader>
    </div>
    <div className="container page">
      <div className="row">
        <div className="col-xl">
          <div className="heading">
            <h1>About F.I. Lighthouse</h1>
          </div>
          <p>
            The Fire Island Lighthouse is an iconic landmark on the western end of the island.  Located within Fire Island National Seashore, the lighthouse provides visitors with an amazing panoramic view of the Great South Bay, Fire Island, and the Atlantic Ocean.  
          </p>
          <p>
            The current lighthouse stands 180 feet tall, and was built in 1858.It dwarfs the original 1826 lighthouse which stood at only 74ft.  The Fire Island Lighthouse has served as a navigational aid for local mariners and was the first light immigrants saw when coming to America in the 1800s.   The lighthouse light remained dark for twelve years (1974-1986 when the United States Coast Guard decommissioned the tower.  Luckily the Fire Island Lighthouse Preservation Society was formed and raised over $1.2 million to relight the light on Memorial Day of 1986.  
          </p>
          <p>
            Today, the lighthouse is run by volunteers who share their passion for the history of Fire Island, the lighthouse, and Long Island..  Guests visiting the lighthouse can visit the museum, see the original glass lens, and even purchase a memento at the gift shop. 
          </p>
        </div>
        <div className="col-xl-4">
          <Instagram account="fiferries" datestamp="June 21, 2018" profile={fiferries} image={sunsetLighthouse} link="https://www.instagram.com/p/BkTDk-IhW43/?taken-by=fiferries" className="mx-auto" />
        </div>
      </div>
      <Tip title="Captain's Tip">
        Hop aboard one of our water taxi's to get a bay side view of the Fire Island Lighthouse.
      </Tip>
      <h1>Transportation</h1>
      <p>
        Transportation to and from the F.I. Lighthouse is available from other Fire Island locations through the <a href="http://www.fireislandwatertaxi.com">Fire Island Water Taxi</a> during in-season operation.
      </p>
      <p>
        Walking to the Lighthouse is also possible by parking at Field 5 at Robert Moses State Park and following the marked walking trail.
      </p>
      <Island />
    </div>
  </div>
);
